export const buildAiReplyRequest = ({
  message,
  threadDetail,
  accountId,
  userId,
  inboxId,
  formattedPhone,
}) => {
  const question = String(message?.content || "").trim();
  if (!question) return { error: "" };
  if (!accountId) return { error: "Missing account context" };
  if (!userId) return { error: "Missing user context" };
  if (!inboxId) return { error: "Missing inbox context" };

  const payload = {
    account_id: String(accountId),
    user_id: String(userId),
    inbox_id: String(inboxId),
    question,
  };
  const source = message?.message_source;
  const sourceIsAirbnb = Array.isArray(source)
    ? source.some((item) => String(item?.ota || "").toLowerCase() === "airbnb")
    : String(source || "").toLowerCase() === "airbnb";
  // Older shared-inbox snapshots omit message sources. Only infer Airbnb for
  // a pure OTA thread; mixed guest/contact conversations retain the SMS path.
  const sources = Array.isArray(threadDetail?.sources) ? threadDetail.sources : [];
  const isAirbnb = sourceIsAirbnb || (
    (!source || (Array.isArray(source) && source.length === 0)) &&
    !threadDetail?.guest_id && !threadDetail?.contact_id &&
    sources.length > 0 && sources.every((item) => String(item?.ota || "").toLowerCase() === "airbnb")
  );
  if (isAirbnb) {
    const threadId = threadDetail?.id ?? threadDetail?.thread_id;
    if (!threadId) return { error: "Missing Airbnb conversation context" };
    return {
      payload: { ...payload, message_source: "airbnb", thread_id: String(threadId) },
    };
  }
  if (!formattedPhone)
    return { error: "Missing guest phone for AI suggestion" };
  return { payload: { ...payload, formatted_phone: String(formattedPhone) } };
};
